import { lazy } from "react";

export { HISTORICAL_DATA_IMPORT_LIST_PATH } from "./historical-data-import-path";

export const HistoricalDataImportListPage = lazy(
  () => import("./historical-data-import"),
);
